module.exports = __webpack_public_path__ + "img/logo.ff35113f.png";